<template>
    <div id="case">
        <Header></Header>
        <div class="case-img"></div>
    </div>
</template>

<script>
    import {onloadRefresh} from '../utils/imgRefresh'
    import Header from '../pages/header/header'
    export default {
        name: "lePao",
        components:{
            Header
        },
        mounted() {
            onloadRefresh(this,require(`../assets/lepao/乐跑.png`))
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/css/public";
</style>
